class CollectionShop extends HTMLElement {
  colors;
  weights;
  input;
  image;
  form;
  options;
  variants;
  prices;
  quantityInputs;
  weightLabel;
  quickAdd;
  variantId;
  variant;
  triggers;
  thumbnail;
  quantity;
  quantitySelector;
  colorsWrapper1;
  colorsWrapper2;

  constructor() {
    super();

    this.variants = window.theme.collectionProducts[this.dataset.product];
    
    if (this.dataset.quickAdd !== 'true') {
      return;
    }

    this.colors = this.querySelector('.swatch-element.color') || this.querySelector('.blanket-options_select');
    
    // Find weight swatches only outside the quick-add form (on card surface)
    const allWeights = this.querySelectorAll('.swatch.weight');
    this.weights = null;
    for (let i = 0; i < allWeights.length; i++) {
      if (!allWeights[i].closest('.quick-add-form')) {
        this.weights = allWeights[i];
        break;
      }
    }
    
    this.input = this.querySelector('[name="id"]');
    // Select the main product image, not thumbnails or other images
    // Ensure we only select images within this specific card element
    const cardWrapper = this.querySelector('.card-wrapper');
    if (cardWrapper) {
      this.image = cardWrapper.querySelector('.card__inner .media img.cover-image');
      if (!this.image) {
        this.image = cardWrapper.querySelector('.card .media img.cover-image');
      }
      if (!this.image) {
        this.image = cardWrapper.querySelector('.card__inner .media img:not([class*="quick-add"])');
      }
      if (!this.image) {
        this.image = cardWrapper.querySelector('.media img.cover-image');
      }
      if (!this.image) {
        // Last resort - get first image in .media that's not in quick-add
        const mediaContainer = cardWrapper.querySelector('.card__inner .media, .card .media, .media');
        if (mediaContainer) {
          const images = mediaContainer.querySelectorAll('img');
          for (let img of images) {
            if (!img.closest('.quick-add')) {
              this.image = img;
              break;
            }
          }
        }
      }
    } else {
      // Fallback to original logic if card-wrapper not found
      this.image = this.querySelector('.card__inner .media img.cover-image');
      if (!this.image) {
        this.image = this.querySelector('.card .media img.cover-image');
      }
      if (!this.image) {
        this.image = this.querySelector('.card__inner .media img:not([class*="quick-add"])');
      }
      if (!this.image) {
        this.image = this.querySelector('.media img.cover-image');
      }
    }
    this.form = this.querySelector('.quick-add-form');
    
    // Safely get color and weight values with null checks
    const colorInput = this.colors?.querySelector('input:checked');
    const weightInput = this.weights?.querySelector('input:checked');
    
    if (this.weights && colorInput && weightInput) {
      this.options = [colorInput.value, weightInput.value];
    } else if (colorInput) {
      this.options = [colorInput.value];
    } else {
      this.options = [];
    }
    this.weightLabel = this.querySelector('[data-weight]');
    this.prices = this.querySelectorAll('[data-price]');
    this.quantityInputs = this.querySelectorAll('[data-quantity]');
    this.quickAdd = this.querySelector('.quick-add');
    this.discount = this.dataset.discount;
    this.variantId = this.input ? parseInt(this.input.value) : null;
    this.triggers = this.querySelectorAll('[data-quick-add-trigger]');
    this.thumbnail = this.querySelector('.quick-add-thumbnail img');
    this.quantity = 1;
    this.isGiftCard = this.colors ? this.colors.classList.contains('blanket-options_select') : false;
    this.quantitySelector = this.querySelector('.quantity');
    this.colorsWrapper1 = this.querySelector('.quick-add_colors-1');
    this.colorsWrapper2 = this.querySelector('.quick-add_colors-2');
    this.variant = this.variantId ? this.variants.find(((v) => v.id === this.variantId).bind(this)) : null;
    
    if (this.triggers)
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.handleTrigger.bind(this));
      });
    if (this.quantitySelector)
      this.quantitySelector.addEventListener('click', this.handleQuantity.bind(this));
    if (this.colors) this.colors.addEventListener('change', this.handleColors.bind(this));
    if (this.weights) this.weights.addEventListener('change', this.handleWeights.bind(this));
    if (this.form) this.form.addEventListener('submit', this.handleForm.bind(this));

    if (this.isGiftCard)
      this.colors.addEventListener('click', function (e) {
        if (e.target.tagName === 'INPUT') return; else if (this.colors.hasAttribute('open')) this.colors.removeAttribute('open'); else this.colors.setAttribute('open', '');
      }.bind(this))

    this.showOnlyAvailableSwatches()
  }

  showOnlyAvailableSwatches(type = 'color') {
    if (!this.colors || this.isGiftCard || !window.theme.hideUnavailableWeights || !this.weights || !this.variant.hasWeight) return;
    if (type === 'color') {
      this.colors.querySelectorAll('input').forEach(color => {
        const find = this.variants.find(variant => variant.options[0] === color.value && variant.available)
        if (!find) color.nextElementSibling.setAttribute('hidden', '')
        else color.nextElementSibling.removeAttribute('hidden')
      })

      if (!this.variant.available) {
        const weight = [...this.weights.querySelectorAll('input')].find(weight => {
          const find = this.variants.find(variant => variant.options[1] === weight.value && variant.available && variant.options[0] === this.variant?.options?.[0])
          return !!find
        })

        weight.nextElementSibling.click()
      } else {
        this.weights.querySelectorAll('input').forEach(weight => {
          const find = this.variants.find(variant => variant.options[1] === weight.value && variant.available && variant.options[0] === this.variant?.options?.[0])
          if (!find) weight.nextElementSibling.setAttribute('hidden', '')
          else weight.nextElementSibling.removeAttribute('hidden')
        })
      }
    } else {
      this.weights.querySelectorAll('input').forEach(weight => {
        const find = this.variants.find(variant => variant.options[1] === weight.value && variant.available && variant.options[0] === this.variant?.options?.[0])
        if (!find) weight.nextElementSibling.setAttribute('hidden', '')
        else weight.nextElementSibling.removeAttribute('hidden')
      })

      if (!this.variant.available) {
        const color = [...this.colors.querySelectorAll('input')].find(color => {
          const find = this.variants.find(variant => variant.options[0] === color.value && variant.available && variant.options[1] === this.variant?.options?.[1])
          return !!find
        })

        color.nextElementSibling.click()
      }
    }
  }

  getTotalPrice() {
    const intPrice = parseInt(this.variant.price.replace('$', ''));
    
    let total = intPrice * this.quantity;
    if (this.discount) {
      const discountAmount = total * (this.discount / 100);
      total -= discountAmount;
    }
    return '$' + Math.round(total);
  }

  switchColors(original) {
    if (window.innerWidth > 989 || (window.innerWidth < 990 && !this.colorsWrapper2))
      return;
    let initial;
    let final;
    if (original) {
      initial = this.colorsWrapper2;
      final = this.colorsWrapper1;
    }
    else {
      initial = this.colorsWrapper1;
      final = this.colorsWrapper2;
    }
    const element = initial.removeChild(initial.querySelector('fieldset'));
    final.appendChild(element);
  }

  handleTrigger() {
    if (this.quickAdd.hasAttribute('open')) {
      this.quickAdd.removeAttribute('open');
      document.body.classList.remove('body_fade');
      document.body.classList.remove('header_fade');
      this.switchColors(true);
    }
    else {
      this.quickAdd.setAttribute('open', '');
      document.body.classList.add('body_fade');
      document.body.classList.add('header_fade');
      this.switchColors(false);
    }
  }

  handleQuantity(e) {
    const el = e.target;
    const isMinus = el.classList.contains('quantity__button-minus');
    const isPlus = el.classList.contains('quantity__button-plus');
    if (el.tagName !== 'BUTTON' || (isMinus && this.quantity === 1) || (isPlus && this.quantity === 99))
      return;
    this.quantity = isMinus ? this.quantity - 1 : isPlus ? this.quantity + 1 : this.quantity;
    this.quantityInputs.forEach((input) => {
      input.value = this.quantity.toString();
    });
    this.form.querySelector('button > [data-price]').innerHTML = this.getTotalPrice();
  }

  handleColors(e) {
    // The change event fires on the input, but e.target might be label in some browsers
    // Find the checked input to get the correct value
    const checkedInput = this.colors.querySelector('input:checked');
    
    if (!checkedInput || !checkedInput.value) {
      return;
    }
    
    this.options[0] = checkedInput.value;

    if (this.isGiftCard) {
      this.variant = this.variants.find((vari) => vari.options[0] === this.options[0] && vari.options[1] === this.options[1]);
    }
    else {
      const oldSizes = this.variant?.sizes?.join(',') || '';
      
      // Reset variant to ensure we find the correct one
      let foundVariant = null;
      
      // If we have weight swatches on card surface AND a selected weight, try to find exact match
      if (this.weights && this.options[1]) {
        foundVariant = this.variants.find((vari) => vari.options[0] === this.options[0] && vari.options[1] === this.options[1]);
      }
      
      // If no exact match, find first variant for this color (preferably available)
      if (!foundVariant) {
        // First try to find an available variant with this color
        foundVariant = this.variants.find((vari) => vari.options[0] === this.options[0] && vari.available);
        // If no available variant, just get first variant with this color
        if (!foundVariant) {
          foundVariant = this.variants.find((vari) => vari.options[0] === this.options[0]);
        }
      }
      
      this.variant = foundVariant;
      
      // Update the selected weight in options array if variant has one
      if (this.variant && this.variant.options[1]) {
        this.options[1] = this.variant.options[1];
      }
      
      // Only update weight swatch if there are weight swatches on the card surface
      if (this.weights && this.variant?.sizes && oldSizes !== this.variant.sizes.join(',')) {
        const input = this.weights.querySelector('input[value="' + this.variant.options[1] + '"]');
        if (input) {
          input.click();
        }
      }
      
      if (this.variant?.image && this.image) {
        // Double-check that the image is still within this card element
        if (!this.contains(this.image)) {
          // Re-find the image if it's not in this card
          const cardWrapper = this.querySelector('.card-wrapper');
          if (cardWrapper) {
            this.image = cardWrapper.querySelector('.card__inner .media img.cover-image') || 
                        cardWrapper.querySelector('.card .media img.cover-image') ||
                        cardWrapper.querySelector('.media img.cover-image');
          }
        }
        
        if (this.image && this.contains(this.image)) {
          // Remove srcset if it exists (it can override src)
          if (this.image.hasAttribute('srcset')) {
            this.image.removeAttribute('srcset');
          }
          
          // Remove loading attribute that might interfere
          if (this.image.hasAttribute('loading')) {
            this.image.removeAttribute('loading');
          }
          
          // Force reload by clearing src first, then setting new one
          this.image.src = '';
          
          // Use requestAnimationFrame to ensure the browser processes the empty src
          requestAnimationFrame(() => {
            if (this.image && this.contains(this.image)) {
              this.image.src = this.variant.image;
            }
          });
        }
      }
      if (this.thumbnail && this.variant?.original_image) {
        this.thumbnail.src = this.variant.original_image;
      }
    }

    
    
    if (!this.variant) return;

    this.input.value = this.variant.id;
    if (this.variant.id == '44420337828026' || this.variant.id == '44420338254010' || this.variant.id == '44420338647226' ) {
      this.prices.forEach((price) => {
        price.innerHTML = price.parentElement.tagName === 'BUTTON' ? '$49' : '$49';
      });
    }
    else {
      this.prices.forEach((price) => {
        price.innerHTML = price.parentElement.tagName === 'BUTTON' ? this.getTotalPrice() : this.variant.price;
      });
    }
    if (this.variant.available)
      this.removeAttribute('soldout');
    else
      this.setAttribute('soldout', '');

    this.showOnlyAvailableSwatches()
  }

  handleWeights(e) {
    this.options[1] = e.target.value;
    this.variant = this.variants.find((variant) => variant.options[0] === this.options[0] && variant.options[1] === this.options[1]);
    this.input.value = this.variant.id;

    if (this.variant.hasWeight)
      this.weightLabel.innerHTML = this.options[1] + ' lbs ' + window.theme.getDimension(this.options[1]);
    else if (this.variant.hasSize && !this.isGiftCard) {
      let option = this.options[1];
      if (option === 'Small' && this.variant.title === 'Pupper Pod') option = 'Small1';
      else if (option === 'Medium' && this.variant.title === 'Pupper Pod') option = 'Medium1';
      this.weightLabel.innerHTML = this.options[1] + window.theme.getDimension(option);
    } else
      this.weightLabel.innerHTML = this.options[1];

    this.prices.forEach(((price) => {
      if (this.variant.options[0] == 'Kaleidoscope' || this.variant.options[0] == 'Flora' || this.variant.options[0] == 'Mist'  ) {
        price.innerHTML = price.parentElement.tagName === 'BUTTON' ? '$49' : '$49';
      } else {
      price.innerHTML = price.parentElement.tagName === 'BUTTON' ? this.getTotalPrice() : this.variant.price;
      }
    }).bind(this));

    if (this.variant.image) {
      // Ensure we're updating the correct image for this card
      if (!this.image || !this.contains(this.image)) {
        const cardWrapper = this.querySelector('.card-wrapper');
        if (cardWrapper) {
          this.image = cardWrapper.querySelector('.card__inner .media img.cover-image') || 
                      cardWrapper.querySelector('.card .media img.cover-image') ||
                      cardWrapper.querySelector('.media img.cover-image');
        }
      }
      
      if (this.image && this.contains(this.image)) {
        this.image.src = this.variant.image;
      }
    }

    if (this.variant.available)
      this.removeAttribute('soldout');
    else
      this.setAttribute('soldout', '');

    this.showOnlyAvailableSwatches('weight')
  }

  handleForm(e) {
    e.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute('disabled', 'true');
    submitButton.classList.add('loading');
    const body = JSON.stringify({
      ...JSON.parse(window.theme.utils.serializeForm(this.form))
    });
    fetch('/cart/add', { ...window.theme.fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        window.theme.cart.render(true);
      })
      .catch((err) => {
        console.error(err);
        e.target.submit();
      })
      .finally(() => {
        this.quickAdd.removeAttribute('open');
        this.switchColors(true);
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

if (!customElements.get('collection-shop')) {
  customElements.define('collection-shop', CollectionShop);
}

document.querySelectorAll('.quick-add').forEach(element => {
  element.addEventListener('click', function() {
      setTimeout(() => {
          this.classList.add('active-click');
      }, 500);
  });
});
